<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Locks">Locks</b-breadcrumb-item>
            <b-breadcrumb-item active>Edit</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Edit Lock</div>
                <div class="card-body">
                    <div class="row pb-3">
                        <b-form-group class="col-lg-2 col-md-4 col-sm-12" label="Lock Type" v-slot="{ lockTypeValue }">
                            <b-form-radio-group
                              v-model="lockType"
                              :options="lockTypes"
                              :aria-describedby="lockTypeValue"
                              disabled
                            ></b-form-radio-group>
                        </b-form-group>
                        <div v-if="buildingId !== null || buildingSpaceId !== null" class="col-lg-4 col-sm-12 form-group">
                            <label for="buildingId">Building</label>
                            <input class="form-control" v-model="buildingName" readonly />
                        </div>
                        <div v-if="buildingSpaceId !== null" class="col-lg-4 col-sm-12 form-group">
                            <label for="buildingSpaceId">{{ spaceType }}</label>
                            <input class="form-control" v-model=spaceIdentity readonly />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-12 form-group">
                            <label for="lockIdentity">Notes/Name/Location</label>
                            <input :class="{'is-invalid': $v.lockIdentity.$invalid && isValidating}"
                                    class="form-control"
                                    maxlength="30"
                                    v-model="lockIdentity"/>
                        </div>
                    </div>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'Locks'}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import FacilitiesLocksService from "@/services/FacilitiesLocksService";
    import {required, requiredIf} from "vuelidate/lib/validators";

    export default {
        data() {
            return {
                isSubmitting: false,
                lockType: null,
                buildingId: null,
                buildingSpaceId: null,
                buildingName: null,
                spaceType: null,
                spaceIdentity: null,
                lockIdentity: null,
                lockTypes: [
                    {
                        value: 0,
                        text: 'Other'
                    },
                    {
                        value: 1,
                        text: 'Entrance'
                    }
                ],
                isValidating: false
            }
        },
        props: {
            id: {
              type: String,
              required: true
            }
        },
        methods: {
            loadData () {
              const vm = this;

              FacilitiesLocksService.getFacilitiesLock(this.id)
                  .then(response => {
                      const lockTypeName = vm.lockTypes.find(e => { return e.text == response.lockType });
                      if (lockTypeName) {
                        vm.lockType = lockTypeName.value;
                      }
                      else {
                        vm.lockType = null;
                      }
                      vm.buildingId = response.buildingId;
                      vm.buildingSpaceId = response.buildingSpaceId;
                      vm.buildingName = response.buildingName;
                      vm.spaceType = response.spaceType;
                      vm.spaceIdentity = response.spaceIdentity;
                      vm.lockIdentity = response.lockIdentity;
                  }).catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)

                      // Redirect to the buildings page
                      vm.$router.replace({name: 'Locks'})
                  })
            },

            /**
             * @description Updates a lock and redirects if successful
             */
            onSubmit() {
                const vm = this;
                vm.isValidating = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                FacilitiesLocksService.updateFacilitiesLock(this.id, {
                  lockIdentity: vm.lockIdentity,
                  lastModifiedByPersonId: vm.$store.getters.user.id
                })
                    .then(() => {
                      vm.alert(ToastType.Success, "The lock was successfully updated");

                      // Redirect to the locks page
                      vm.$router.replace({name: 'Locks'})
                    })
                    .catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)
                    })
                    .finally(() => {
                      vm.isSubmitting = false;
                      vm.isValidating = false;
                    })
            }
        },
        created() {
            this.id = this.$route.params.id;
            this.loadData();
        },
        validations: {
          lockIdentity: {
            required: requiredIf (function (value) {
              return value.lockType == 0;
            })
          }
        }
    }
</script>
